// Web Mercator (EPSG:3857) helpers in normalized "world" units (0..1).
// Matches the projection Google Static Maps uses, so map pins computed with
// these helpers line up with the rendered tile regardless of container size.

/** Longitude (deg) -> normalized world X (0 at -180°, 1 at +180°). */
export function mercX(lng: number): number {
  return (lng + 180) / 360;
}

/** Latitude (deg) -> normalized world Y (0 at north edge, 1 at south edge). */
export function mercY(lat: number): number {
  return (1 - Math.asinh(Math.tan((lat * Math.PI) / 180)) / Math.PI) / 2;
}

/** Inverse of mercX: normalized world X -> longitude (deg). */
export function lngFromMercX(x: number): number {
  return x * 360 - 180;
}

/** Inverse of mercY: normalized world Y -> latitude (deg). */
export function latFromMercY(y: number): number {
  return (Math.atan(Math.sinh(Math.PI * (1 - 2 * y))) * 180) / Math.PI;
}
